import { createFileRoute } from '@tanstack/react-router';
import { productionsList } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { NewCreativeFlow } from '@/screens/new-creative';

export const Route = createFileRoute('/creatives/new')({
  beforeLoad: requireCapability('creatives_edit'),
  loader: ({ context }) => warm(context.queryClient, productionsList({})),
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <NewCreativeFlow setView={setView} />;
}
